import { Product, Order, InvestmentPlan } from "src/app/models/orders";

export interface ITradingState {
  products: Product[];
  orders: Order[];
  investmentPlan: Partial<InvestmentPlan>;
  loading: boolean;
}

export const initialTradingState: ITradingState = {
  products: null,
  orders: null,
  investmentPlan: null,
  loading: false,
};
